module.exports = __webpack_public_path__ + "static/media/IMG_2400.0e128411.jpg";